import React from 'react';
import { BaseResourceListProps, SimpleList, SvgBin, SvgEdit } from '@app/components';
import { IAdvertisement } from '@app/common';
import { theme } from '@app/theme';
import { createColumnHelper } from '@tanstack/react-table';
import { useTable } from '@app/hooks/useTable';
import { advertisementApi } from '@app/store/services/advertisement';
import { CheckPermissions } from '@app/components/CheckPermissions';

const columnHelper = createColumnHelper<IAdvertisement>();

export const AdvertisementList = ({ onUpdate, onDelete, onRowPress, selectedRowItem }: BaseResourceListProps<IAdvertisement>) => {
  const columns = [
    columnHelper.accessor('name', {
      header: () => (
        <SimpleList.HeaderItem width="75%">
          <SimpleList.HeaderItemLabel>Nom</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: (info) => {
        const advertisement = info.row.original;
        const imageUrl = advertisement.images?.medium?.webp?.url;

        return (
          <SimpleList.ItemCol width="75%">
            <SimpleList.ItemImageWrapper>
              <SimpleList.ItemImage source={imageUrl} alt={info.getValue()} />
              <SimpleList.ItemText align="left" bold numberOfLines={2} active={info.active}>
                {info.getValue()}
              </SimpleList.ItemText>
            </SimpleList.ItemImageWrapper>
          </SimpleList.ItemCol>
        );
      },
    }),
    columnHelper.display({
      id: 'actions',
      header: () => (
        <SimpleList.HeaderItem width="25%" align='center'>
          <SimpleList.HeaderItemLabel>Actions</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: ({ row, active }) => (
        <SimpleList.ItemCol width="25%">
          <SimpleList.ItemActions>
            <CheckPermissions permissions={['dashboard::advertisements.update']}>
              <SimpleList.ItemAction onPress={() => onUpdate(row.original)}>
                <SvgEdit color={active ? '#FFF' : theme.colors.celadonblue} />
              </SimpleList.ItemAction>
            </CheckPermissions>

            <CheckPermissions permissions={['dashboard::advertisements.delete']}>
              <SimpleList.ItemAction onPress={() => onDelete(row.original)}>
                <SvgBin color={active ? '#FFF' : theme.colors.celadonblue} />
              </SimpleList.ItemAction>
            </CheckPermissions>
          </SimpleList.ItemActions>
        </SimpleList.ItemCol >
      ),
    }),
  ];

  const { table, setSearch, isFetching } = useTable({
    columns,
    useQuery: ({ pagination, search }) => advertisementApi.useReadManyAdvertisementsQuery({
      pagination,
      populate: ['shopIds'],
      filters: {
        name: {
          $contains: search
        }
      },
      sort: ['name:ASC'],
    })
  });

  return <SimpleList
    table={table}
    isFetching={isFetching}
    onSearch={setSearch}
    selectedRowItem={selectedRowItem}
    onRowPress={onRowPress} />;
};
